module.exports = __webpack_public_path__ + "media/assets/plane-1-bw-34e73b565d9eaa231346d88aca8c7677.svg";